import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { originalKeyValueOrder } from '@import/functions/original-key-value-order';
import { validateRequiredWithConstraints } from '@import/functions/required-humi-columns/validate-required-with-constraints';
import { MappingTableSection as MappingTableSectionInterface } from '@import/interfaces';
import { ColumnRequiredService } from '@import/services';
import flattenDepth from 'lodash-es/flattenDepth';

@Component({
    selector: 'app-mapping-table-section',
    templateUrl: './mapping-table-section.template.html',
    styleUrls: ['./mapping-table-section.style.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class MappingTableSection {
    @Input() section: MappingTableSectionInterface;
    @Output() triggerValidation: EventEmitter<void> = new EventEmitter();

    originalKeyValueOrder = originalKeyValueOrder;
    isSectionValid = true;

    constructor(public columnRequiredService: ColumnRequiredService) {}

    setIsSectionValid(): void {
        const sectionColumns = flattenDepth(Object.values(this.section), 1);
        this.columnRequiredService.setConditionallyRequiredColumnTypes(sectionColumns);
        this.isSectionValid = validateRequiredWithConstraints(sectionColumns);
        this.triggerValidation.emit();
    }
}
